
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/configurable",
      function () {
        return require("private-next-pages/configurable.tsx");
      }
    ]);
  